<template>
  <div class="select">
    <div class="select__label">{{ label }}</div>
    <select
      class="select__element"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="updateSelf($event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
      <slot></slot>
    </select>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: ['value', 'type', 'label', 'placeholder', 'disabled'],
  methods: {
    updateSelf (name) {
      this.$emit('input', name)
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  &__label {
    @include labelStyle();
  }

  &__element {
    @include inputStyle(5px);
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:focus {
      outline: 0;
    }
  }
}
</style>
